import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

export type ResponseType<T> = {
  success: boolean
  message: string
  totalData?: number
  totalPage?: number
  currentPage?: number
  nextPage?: boolean
  data: T
}

// function getCookie(name: string) {
//   const matches = document.cookie.match(new RegExp(
//     `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`
//   ));
//   return matches ? decodeURIComponent(matches[1]) : undefined;
// }

const instance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_API,
  timeout: 10000,
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
})

instance.interceptors.request.use(
  async (config) => {
    config.headers['Accept'] = 'application/json'

    const token = localStorage.getItem('token')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error),
)

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('Unauthorized. Logging out...')
    }
    return Promise.reject(error)
  },
)

const apiRequest = {
  getCsrfCookie(): Promise<AxiosResponse<void>> {
    return instance.get('/sanctum/csrf-cookie')
  },
  get<T = any>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    return instance.get<T>(url, config)
  },

  post<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    return instance.post<T>(url, data, config)
  },

  put<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    return instance.put<T>(url, data, config)
  },

  delete<T = any>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    return instance.delete<T>(url, config)
  },
}

export default apiRequest
